
module.exports = {
  brand: function(d) { return "THE OUTNET"; },
  contact: {
    title: function(d) { return "お困りですか？"; },
    copyBeforeLink: function(d) { return "THE OUTNET"; },
    copyAfterLink: function(d) { return " までお問い合わせください。"; },
    href: function(d) { return "/page/help/returns/"; },
    customerCare: function(d) { return "カスタマーケア"; }
  },
  search: {
    text: function(d) { return "THE OUTNET 検索"; },
    clear: function(d) { return "クリア"; },
    categories: function(d) { return "カテゴリー"; },
    designers: function(d) { return "ブランド"; },
    products: function(d) { return "アイテム"; },
    colours: function(d) { return "カラー"; },
    cta: function(d) { return "検索"; },
    noResult: function(d) { return d.searchTerm + " に一致する検索結果がありません。"; },
    tryAgain: function(d) { return "もう一度お試しください"; },
    loading: function(d) { return "検索中"; },
    viewAll: function(d) { return "検索結果を見る (" + d.count + ")"; }
  },
  price: {
    discountPercentage: function(d) { return d.discountPercentage + "%OFF"; },
    discountPrice: function(d) { return "割引額"; },
    currencyExchange: function(d) { return "(概算 " + d.exchangeCurrency + " " + d.exchangePrice + ")"; },
    wasPriceOriginal: function(d) { return "希望小売価格: " + d.wasPrice; },
    wasPrice: function(d) { return "希望小売価格:"; },
    originalPrice: function(d) { return "元の価格:"; }
  },
  localeSwitch: {
    languages: {
      en: function(d) { return "English"; },
      ar: function(d) { return "اللغة العربية"; },
      de: function(d) { return "Deutsch"; },
      fr: function(d) { return "française"; },
      ja: function(d) { return "日本語"; },
      ko: function(d) { return "한국어"; }
    },
    changeCountry: {
      title: function(d) { return "国・配送国の変更"; },
      description: function(d) { return "ご利用の国/地域をお選びください"; }
    },
    itemsUnavailable: {
      title: function(d) { return "完売しました"; },
      description: function(d) { return "申し訳ございません。ショッピングバッグ内にこちらの国/地域ではお取り扱いしていない商品があります。国/地域を変更すると該当の商品はショッピングバッグから削除されます"; },
      confirmation: function(d) { return "国/地域を変更する"; },
      addToWishlist: function(d) { return "ウィッシュリストに追加する"; }
    }
  },
  cookieBanner: {
    title: function(d) { return "クッキーおよびプライバシーポリシー"; },
    message: function(d) { return "当サイトでは広告配信を目的にサードパーティを含めた第三者のクッキー(Cookie)を使用しています。閲覧を続けることでお客様はクッキーポリシーに同意したとみなされます。"; },
    cta: function(d) { return "クッキーポリシーはこちら"; },
    href: function(d) { return "/page/help/cookie-policy"; }
  },
  nav: {
    myAccount: {
      text: function(d) { return "こんにちは " + d.name + "様"; },
      href: function(d) { return "/account"; }
    },
    myAccountMobile: {
      text: function(d) { return "マイアカウント"; }
    },
    signIn: {
      text: function(d) { return "サインイン"; },
      href: function(d) { return "/account/login"; }
    },
    signOut: {
      text: function(d) { return "サインアウト"; },
      href: function(d) { return "/account/login"; }
    },
    account: {
      text: function(d) { return "マイアカウント"; },
      href: function(d) { return "/account"; }
    },
    wishlist: {
      text: function(d) { return "ウィッシュリスト"; },
      href: function(d) { return "/account/wishlist"; }
    },
    checkout: {
      text: function(d) { return "ショッピングバッグ"; },
      href: function(d) { return "/checkout"; }
    },
    register: {
      text: function(d) { return "アカウント新規登録"; },
      href: function(d) { return "/account/login"; }
    }
  },
  courtesyNav: {
    customerServiceInfo: {
      text: function(d) { return "カスタマーケア"; },
      href: function(d) { return "/page/help/contact-us"; }
    },
    deliveryInfo: {
      text: function(d) { return "配送"; },
      href: function(d) { return "/page/help/customer-service/delivery"; }
    },
    returnsInfo: {
      text: function(d) { return "返品・返金"; },
      href: function(d) { return "/page/help/customer-service/returns"; }
    },
    myOrders: {
      text: function(d) { return "ご注文履歴"; },
      href: function(d) { return "/account/orders"; }
    },
    trackOrder: {
      text: function(d) { return "配送状況の確認"; },
      href: function(d) { return "/account/track-order"; }
    },
    createReturn: {
      text: function(d) { return "返品フォームの作成"; },
      href: function(d) { return "/account/create-return"; }
    }
  },
  copyright: {
    yearFrom: function(d) { return "2009 - "; },
    copy: function(d) { return ", part of YOOX NET-A-PORTER GROUP."; },
    extraCopy: function(d) { return "当サイトやニュースレターに掲載されている人物はTHE OUTNETや商品の宣伝を目的として登場しておりません。またTHE OUTNETやブランド､商品とは一切関係ありません。"; }
  },
  social: {
    title: function(d) { return "Stay Social"; }
  },
  externalLinks: {
    mrp: function(d) { return "https://www.mrporter.com/"; },
    nap: function(d) { return "https://www.net-a-porter.com/"; }
  },
  error: {
    megaNav: function(d) { return "申し訳ございません。お探しのページが見つかりませんでした"; }
  },
  checkout: {
    copy: function(d) { return "チェックアウト"; }
  },
  footer: {
    footerLinks: function(d) { return "お問い合わせ＆ヘルプ"; },
    contactAndLocale: function(d) { return "カスタマーケア"; },
    signupAndSocial: function(d) { return "Stay Social"; }
  },
  fastUserRegistration: {
    heading: function(d) { return "ニュースレターに登録しませんか？"; },
    description: function(d) { return "新着アイテムやセール情報などの情報満載のTHE OUTNETニュースレターにご登録いただくと、次回のショッピングが15％OFFになるプロモコードを進呈いたします。"; },
    exclusionsText: function(d) { return "*一部対象外・利用規約あり"; },
    exclusionsLink: function(d) { return "https://www.theoutnet.com/page/policies/general-terms-and-conditions-of-sale/#promotional-codes"; },
    subscribe: function(d) { return "登録"; },
    placeholder: function(d) { return "メールアドレスを入力してください"; },
    sucessfulEmailMessage: function(d) { return "ニュースレターにご登録いただき､ありがとうございます！"; },
    NoEmailMessage: function(d) { return "メールアドレスを入力してください"; },
    invalidEmailMessage: function(d) { return "メールアドレスが無効です"; }
  },
  seoMeta: {
    title: function(d) { return "海外人気ラグジュアリーブランドが最大70%OFF｜THE OUTNET(アウトネット)"; },
    description: function(d) { return "350以上の海外人気ラグジュアリーブランドをスペシャルプライスでご提供！THE OUTNETで欲しかった人気アイテムと新しいコーディネートのヒントを見つけて。"; }
  },
  webpush: {
    title: function(d) { return "最新プロモーションやお得な情報をもれなく受け取るにはプッシュ通知をONに設定してください"; },
    description: function(d) { return ""; },
    toggleMessage: function(d) { return "プッシュ通知をONにする"; }
  },
  multishop: {
    mens: function(d) { return "メンズ"; },
    womens: function(d) { return "レディース"; }
  },
  promptBasketItem: {
    title: function(d) { return "ショッピングバッグに追加しました"; },
    button: function(d) { return "ショッピングバッグに進む"; }
  }
}